import { Routes } from '@angular/router';

export interface BackofficeSection {
  id: string;
  label: string;
  description: string;
  icon: string;
  requiredRealmRoles: string[];
  route: string;
  loadChildren: () => Promise<Routes>;
}

export const BACKOFFICE_SECTIONS: BackofficeSection[] = [
  {
    id: 'moderation',
    label: 'Moderazione',
    description: 'Segnalazioni, sanzioni e storico utenti',
    icon: 'pi pi-flag',
    requiredRealmRoles: ['moderator', 'admin'],
    route: 'moderation',
    loadChildren: () => import('../features/moderation/moderation.routes').then((m) => m.MODERATION_ROUTES)
  }
];
